{
  "CheckActivity": {
    "menuItem": "x<strong>{{count}}</strong> {{name}}",
    "menuItemPrice": "{{value, currency(USD)}}"
  },
  "CheckItemButton": {
    "modifierNamePlusCost": "{{name}} (+{{cost}})",
    "modifierNameWithCost": "{{name}} ({{cost}})",
    "modifierNameWithCount": "x{{count}} {{name}}",
    "modifierNameWithCountPlusCost": "x{{count}} {{name}} (+{{cost}})",
    "modifierNameWithCountWithCost": "x{{count}} {{name}} ({{cost}})"
  },
  "apiHealth": {
    "errors": {
      "getHealth": "get API health"
    }
  },
  "app": {
    "error": {
      "client": {
        "form": {
          "message": "Resolve Validation Errors",
          "title": "Invalid User Entry"
        }
      },
      "dataPrimer": {
        "message": "Some essential data failed to load",
        "title": "Essential data error encountered."
      },
      "unexpected": {
        "message": "An unexpected major error was encountered. Please click <0>here</0> to reload and try again.",
        "title": "Unexpected error encountered."
      }
    },
    "page": {
      "title": "SALIDO"
    },
    "startUp": "app is starting up",
    "symbols": {
      "command": "⌘"
    }
  },
  "approvalRequest": {
    "errors": {
      "approve": "approve auth request",
      "cancel": "cancel auth request",
      "deny": "deny auth request"
    },
    "information": "Ask an authorized user to swipe employee card or enter PIN to approve.",
    "label": "Approval Request",
    "label_plural": "Approval Requests",
    "labels": {
      "approvalRequested": "Approval Requested",
      "approvalRequestedCheck": "Approval Requested • {{checkLabel}}",
      "authorizationDenied": "Authorization Denied",
      "authorizationRequestFrom": "Authorization Request from {{employeeName}}",
      "cancelRequest": "Cancel Request",
      "managerApprovalNeeded": "Manager Approval Needed",
      "request": "Request"
    },
    "notificationHeaders": {
      "pos.checks.86Items.create": "<primary>{{employeeName}}</primary> has requested approval to add the 86'd item <primary>{{itemNames}}</primary> on check <primary>{{target.number}}</primary>. <navigate>View Check</navigate>",
      "pos.checks.create": "<primary>{{employeeName}}</primary> has requested approval to create a check",
      "pos.checks.discounts.create": "{{currentTime}} <primary>{{employeeName}}</primary> has requested approval to apply discount <primary>{{target.discount.name}}</primary> in the amount of </primary>{{target.discount.value}}</primary> to check <primary>{{target.number}} {{target.label}}</primary> with total {{target.total}} because {{target.discount.reason}}. <navigate>View Check</navigate>",
      "pos.checks.discounts.delete": "{{currentTime}} <primary>{{employeeName}}</primary> has requested approval to remove discount <primary>{{target.discount.name}}</primary> from check <primary>{{target.number}} {{target.label}}</primary> in the amount of <primary>{{target.discount.value}}</primary>. <navigate>View Check</navigate>",
      "pos.checks.discounts.manage": {
        "add": "{{currentTime}} <primary>{{employeeName}}</primary> has requested approval to add discount <primary>{{target.discount.name}}</primary> in the amount of <primary>{{target.discount.value, currency(USD)}}</primary> to check <primary>{{target.number}} {{target.label}}</primary> with total <primary>{{target.total, currency(USD)}}</primary> because {{target.discount.reason}}. <navigate>View Check</navigate>",
        "addPercentage": "{{currentTime}} <primary>{{employeeName}}</primary> has requested approval to add discount <primary>{{target.discount.name}}</primary> in the amount of <primary>{{target.discount.value, percent}}%</primary> to check <primary>{{target.number}} {{target.label}}</primary> with total <primary>{{target.total, currency(USD)}}</primary> because {{target.discount.reason}}. <navigate>View Check</navigate>",
        "remove": "{{currentTime}} <primary>{{employeeName}}</primary> has requested approval to remove discount <primary>{{target.discount.name}}</primary> from check <primary>{{target.number}} {{target.label}}</primary> in the amount of <primary>{{target.discount.value, currency(USD)}}</primary> with total <primary>{{target.total, currency(USD)}}</primary>. <navigate>View Check</navigate>",
        "removePercentage": "{{currentTime}} <primary>{{employeeName}}</primary> has requested approval to remove discount <primary>{{target.discount.name}}</primary> from check <primary>{{target.number}} {{target.label}}</primary> in the amount of <primary>{{target.discount.value, percent}}%</primary> with total <primary>{{target.total, currency(USD)}}</primary>. <navigate>View Check</navigate>"
      },
      "pos.checks.fees.manage": {
        "add": "<primary>{{employeeName}}</primary> has requested approval to add fee/gratuity {{target.surcharge.name}} to check <primary>{{target.number}} {{target.label}}</primary>. <navigate>View Check</navigate>",
        "remove": "<primary>{{employeeName}}</primary> has requested approval to delete fee/gratuity {{target.surcharge.name}} from check <primary>{{target.number}} {{target.label}}</primary>. <navigate>View Check</navigate>",
        "update": "<primary>{{employeeName}}</primary> has requested approval to update fee/gratuity {{target.surcharge.name}} on check <primary>{{target.number}} {{target.label}}</primary>. <navigate>View Check</navigate>"
      },
      "pos.checks.items.void": "{{currentTime}} <primary>{{employeeName}}</primary> has requested approval to void <primary>{{itemNames}}</primary> on check <primary>{{target.number}} {{target.label}}</primary> with total <primary>{{target.total, currency(USD)}}</primary> because <primary>{{statusReason}}</primary>. <navigate>View Check</navigate>",
      "pos.checks.merge.execute": "<primary>{{employeeName}}</primary> has requested approval to merge checks <primary>{{target.check1.number}} {{target.check1.label}}</primary> and <primary>{{target.check2.number}} {{target.check2.label}}</primary>",
      "pos.checks.payment.accept.execute": "<primary>{{employeeName}}</primary> has requested approval to take a payment for check <primary>{{target.label}}</primary>. <navigate>View Check</navigate>",
      "pos.checks.payments.refund.execute": "<primary>{{employeeName}}</primary> has requested approval to refund a payment for check <primary>{{target.label}}</primary>. <navigate>View Check</navigate>",
      "pos.checks.prices.update": "<primary>{{employeeName}}</primary> has requested approval to update pricing on check <primary>{{target.label}}</primary>. <navigate>View Check</navigate>",
      "pos.checks.read": "<primary>{{employeeName}}</primary> has requested approval to view checks",
      "pos.checks.reopen.execute": "<primary>{{employeeName}}</primary> has requested approval to reopen check <primary>{{target.number}} {{target.label}}</primary>. <navigate>View Check</navigate>",
      "pos.checks.split.execute": "<primary>{{employeeName}}</primary> has requested approval to split check <primary>{{target.number}} {{target.label}}</primary>. <navigate>View Check</navigate>",
      "pos.checks.tax.update": "<primary>{{employeeName}}</primary> has requested approval to update tax exemption on check <primary>{{target.number}} {{target.label}}</primary>. <navigate>View Check</navigate>",
      "pos.checks.transfer.execute": "<primary>{{employeeName}}</primary> has requested approval to transfer <primary>{{target.number}} {{target.label}}</primary> from <primary>{{target.tableName}}, {{target.fromRevCenter.name}} - {{target.fromEmployee.name}}</primary> to <primary>{{target.toTable.name}}, {{target.toRevCenter.name}} - {{target.toEmployee.name}}</primary>",
      "pos.checks.update": "<primary>{{employeeName}}</primary> has requested approval to update check <primary>{{target.number}} {{target.label}}</primary>. <navigate>View Check</navigate>",
      "pos.checks.void": "<primary><primary>{{employeeName}}</primary></primary> has requested approval to void check <primary>{{target.number}} {{target.label}}</primary>. <navigate>View Check</navigate>",
      "pos.drawer.popAssigned.execute": "<primary>{{employeeName}}</primary> has requested approval to pop the cash drawer",
      "pos.money.payIn.execute": "<primary>{{employeeName}}</primary> has requested approval to perform a pay in",
      "pos.money.payIn.void": "<primary>{{employeeName}}</primary> has requested approval to perform a pay in void",
      "pos.money.payOut.execute": "<primary>{{employeeName}}</primary> has requested approval to perform a pay out",
      "pos.money.payOut.void": "<primary>{{employeeName}}</primary> has requested approval to perform a pay out void",
      "pos.money.tipOut.execute": "<primary>{{employeeName}}</primary> has requested approval to perform a tip out",
      "pos.timeClockOverride.execute": {
        "early": "<primary>{{employeeName}}</primary> has requested approval to clock in early. The expected start time is <primary>{{expectedStartTime}}</primary>. The current time is <primary>{{currentTime}}</primary>.",
        "late": "<primary>{{employeeName}}</primary> has requested approval to clock in late. The expected start time is <primary>{{expectedStartTime}}</primary>. The current time is <primary>{{currentTime}}</primary>.",
        "unscheduled": "<primary>{{employeeName}}</primary> has requested approval to clock in. <primary>{{employeeName}}</primary> is not on the schedule."
      }
    },
    "uiBlockerHeaders": {
      "pos.checks.86Items.create": "You will need a manager's approval to add an 86'd item to check {{target.label}}.",
      "pos.checks.create": "You will need a manager's approval to create a check.",
      "pos.checks.discounts.create": "You will need a manager's approval to apply a discount to check {{target.label}}.",
      "pos.checks.discounts.delete": "You will need a manager's approval to remove a discount from check {{target.label}}.",
      "pos.checks.discounts.manage": "You will need a manager's approval to manage discounts on check {{target.label}}.",
      "pos.checks.fees.manage": {
        "add": "You will need a manager's approval to add {{target.surcharge.name}} to check {{target.label}}.",
        "remove": "You will need a manager's approval to delete {{target.surcharge.name}} from check {{target.label}}.",
        "update": "You will need a manager's approval to update {{target.surcharge.name}} on check {{target.label}}."
      },
      "pos.checks.items.void": "You will need a manager's approval to void {{itemNames}} on check {{target.label}}.",
      "pos.checks.merge.execute": "You will need a manager's approval to merge checks.",
      "pos.checks.payment.accept.execute": "You will need a manager's approval to take a payment for check {{target.label}}.",
      "pos.checks.payments.refund.execute": "You will need a manager's approval to void this payment for check {{target.label}}.",
      "pos.checks.prices.update": "You will need a manager's approval to update pricing on check {{target.label}}.",
      "pos.checks.read": "You will need a manager's approval to view checks.",
      "pos.checks.reopen.execute": "You will need a manager's approval to reopen check {{target.label}}.",
      "pos.checks.split.execute": "You will need a manager's approval to split this check.",
      "pos.checks.tax.update": "You will need a manager's approval to update tax exemption on check {{target.label}}.",
      "pos.checks.transfer.execute": "You will need a manager's approval to transfer checks.",
      "pos.checks.update": "You will need a manager's approval to update check {{target.label}}.",
      "pos.checks.void": "You will need a manager's approval to void check {{target.label}}.",
      "pos.drawer.popAssigned.execute": "You will need a manager's approval to pop the cash drawer.",
      "pos.guests.create": "You will need a manager's approval to create a guest.",
      "pos.guests.update": "You will need a manager's approval to update a guest.",
      "pos.money.payIn.execute": "You will need a manager's approval to perform a pay in.",
      "pos.money.payIn.void": "You will need a manager's approval to perform a pay in void.",
      "pos.money.payOut.execute": "You will need a manager's approval to perform a pay out.",
      "pos.money.payOut.void": "You will need a manager's approval to perform a pay out void.",
      "pos.money.tipOut.execute": "You will need a manager's approval to perform a tip out.",
      "pos.timeClockOverride.execute": {
        "early": "You will need a manager's approval to clock in because you are early. Your expected start time is {{expectedStartTime}}. The current time is {{currentTime}}.",
        "late": "You will need a manager's approval to clock in because you are late. Your expected start time is {{expectedStartTime}}. The current time is {{currentTime}}.",
        "unscheduled": "You will need a manager's approval to clock in because you are not on the schedule."
      }
    }
  },
  "authRequest": {
    "errors": {
      "answer": "answer authorization request",
      "approve": "approve authorization request",
      "cancel": "cancel authorization request",
      "create": "create authorization request"
    }
  },
  "break": {
    "label": "Break",
    "labels": {
      "beginBreak": "current operator begin break",
      "nonApprovedBreak": {
        "body": "This break is not an approved break per the labor rules defined.",
        "title": "Non-Approved Break"
      },
      "takeABreak": "Take a Break",
      "whichBreak": "Which break are you taking?"
    }
  },
  "bridge": {
    "label": "Bridge",
    "labels": {
      "theBridge": "The Bridge"
    }
  },
  "buildInfo": {
    "dependencyVersionsHeader": "Dependency Versions",
    "serverVersion": "{{value}}",
    "serverVersionHeader": "Server Version",
    "serverVersion_error": "Could not get server version: {{error}}",
    "versionHeader": "Version"
  },
  "cardReader": {
    "label": "Card Reader",
    "labels": {
      "connect": "Connect reader",
      "connected": "Card Reader Connected",
      "disconnected": "Card Reader Disconnected"
    }
  },
  "cashBank": {
    "errors": {
      "adjustCloseAmount": "adjust close amount",
      "adjustOpenAmount": "adjust open amount",
      "assignCashBank": "assign cash bank",
      "bankLog_noData": "No $t(cashBank.label) Activity",
      "closeBank": "close cash bank",
      "deposit": "deposit to cash bank",
      "getAllFromLocationOnDay": "get all cash banks from location on day",
      "getAll_noData": "No $t(cashBank.label_plural)",
      "printReport": "print cash bank report",
      "reopenBank": "reopen cash bank",
      "withdrawal": "withdraw from cash bank"
    },
    "info": {
      "bankNotStarted": "Bank Not Started",
      "bankOpen": "Bank Open",
      "noOpenBanks": "No Open Banks"
    },
    "label": "Cash Bank",
    "label_plural": "Cash Banks",
    "labels": {
      "actualAmountInBank": "Actual Amount in the Bank",
      "actualInTheDrawer": "Actual in the Drawer",
      "additionalNotes": "Additional Notes",
      "adjustClosingAmount": "Adjust Closing Amount",
      "adjustStartingAmount": "Adjust Starting Amount",
      "adjustingTheClosingAmount": "Adjust the closing amount to ",
      "adjustingTheStartingAmount": "Adjust the Starting Amount to ",
      "assignTo": "Assign To",
      "assignedTo": "Assigned To",
      "bankClosed": "Bank Closed",
      "bankClosedAt": "Bank closed at {{time}}",
      "bankLog": "Bank Log",
      "bankStartedAt": "Bank Started At {{time}}",
      "cashCollected": "Cash Collected",
      "closeBank": "Close Bank",
      "closingAmount": " Closing Amount",
      "countBills": "Count Bills",
      "countTheBills": "Count the Bills",
      "currentClosingAmount": "Current Closing Amount",
      "currentStartingAmount": "Current Starting Amount:",
      "deposit": "Deposit",
      "depositAmount": "Deposit Amount",
      "depositRecord": "Record Deposit",
      "endingAmount": "Ending Amount",
      "enterAdjustedAmount": "Enter the Adjusted Amount in Dollars",
      "enterAmountDollars": "Enter the Amount in Dollars",
      "expectedAmount": "Expected Amount",
      "expectedInTheDrawer": "Expected in the Drawer",
      "goToSummary": "$t(cashBank.labels.closeBank)",
      "inDollarAmount": "In Dollar Amount",
      "openBank": "Open Bank",
      "openBankWith": "Open Bank with",
      "openNewBank": "Open New Bank",
      "openedAt": "Opened At",
      "reimburseEmployee": "Reimburse Employee",
      "reopenClosedBank": "Reopen Closed Bank",
      "replenishFromFloat": "Replenish from Float",
      "reprintReport": "Reprint Report",
      "startingAmount": "Starting Amount",
      "tipOut": "Tip Out",
      "viewBankLog": "View Bank Log",
      "withdrawal": "Withdrawal",
      "withdrawalAmount": "Withdrawal Amount",
      "withdrawalRecord": "Record Withdrawal"
    }
  },
  "cashDrawer": {
    "error": {
      "assign": "assign cash drawer",
      "noCashDrawer": "Assign a cash drawer to accept cash",
      "unassign": "unassign cash drawer"
    },
    "label": "Cash Drawer",
    "labels": {
      "assignment": "Cash Drawer Assignment",
      "assignmentRequired": "Cash Drawer Assignment Required",
      "assignmentRequiredToContinue": "A cash drawer must be assigned. Continue to cash drawer settings?",
      "confirm": "Confirm Cash Drawer Assignment",
      "drawerAssigned": "Drawer Assigned",
      "managerNeeded": "Manager approval is needed to:"
    },
    "settings": {
      "assign": "Assign",
      "assignedTo": "Assigned to {{name}}",
      "assignedToYou": "Currently Assigned to you",
      "defaultAgpName": "AGP Cash Drawer",
      "drawerIdAndState": "ID: {{drawer.id}} ( {{drawer.state}} )",
      "name": "{{name}}",
      "pairBtn": "Pair",
      "title": "Assign / Un-assign Cash Drawers or Pair a new Drawer",
      "unassign": "Unassign",
      "unassignPromptMessage": "Are you sure you'd like to unassign cash drawer with ID {{drawerId}} from yourself? This will require manager override approval.",
      "unassignPromptTitle": "Unassign Current Cash Drawer?",
      "unassigned": "Unassigned"
    }
  },
  "check": {
    "activities": {
      "autoDiscountAdded": "Discount auto-applied",
      "autoSurchargeAdded": {
        "default": "Fee/Gratuity auto-applied",
        "fee": "Fee auto-applied",
        "gratuity": "Gratuity auto-applied"
      },
      "cardVerify": "Card verify",
      "cleared": "Check cleared",
      "clearedTaxID": "Removed Tax Exemption",
      "closed": "Check closed",
      "created": "Check created",
      "customerUpdated": "Customer updated",
      "discountAdded": "Discount added",
      "discountAutoDisabled": "Auto-applied discount disabled",
      "discountAutoEnabled": "Auto-applied discount enabled",
      "discountDisabled": "Discount disabled",
      "discountEnabled": "Discount enabled",
      "discountRemoved": "Discount removed",
      "giftCardAdded": "Gift Card added",
      "giftCardIssueVoided": "Gift Card issue voided",
      "giftCardIssued": "Gift Card issued",
      "giftCardReloadVoided": "Gift Card reload voided",
      "giftCardReloaded": "Gift Card reloaded",
      "giftCardRemoved": "Gift Card removed",
      "goodFaithPaymentReran": {
        "declined": "Good Faith Payment declined",
        "default": "Good Faith Payment reran"
      },
      "infoEdited": {
        "default": "Check info edited",
        "labelPrefix": "Label Prefix updated",
        "orderType": "Order Type updated",
        "partySize": "Party Size updated"
      },
      "itemAdded": "Item added",
      "itemCompleted": "Item completed",
      "itemEdited": "Item edited",
      "itemIndefiniteHold": "Item indefinite hold",
      "itemIndefiniteHoldRelease": "Item indefinite hold released",
      "itemRemoved": "Item removed",
      "itemRepeated": "Item repeated",
      "itemSent": "Item sent",
      "itemVoided": "Item voided",
      "manualPaymentRequest": "Manual Payment Request",
      "mergedFrom": "Check merged from",
      "mergedFromCheck": "Check merged from {{checkNumber}}",
      "mergedInto": "Check merged into",
      "mergedIntoCheck": "Check merged into {{checkNumber}}",
      "paymentAdded": {
        "declined": "Payment declined",
        "default": "Payment added"
      },
      "paymentRemoved": {
        "declined": "Payment removal declined",
        "default": "Payment removed"
      },
      "paymentUpdated": {
        "declined": "Payment update declined",
        "default": "Payment updated"
      },
      "paymentUpdatedDetails": {
        "tip": "Tip: {{value, currency(USD)}}",
        "total": "Total: {{value, currency(USD)}}"
      },
      "reopened": "Check reopened",
      "setTaxID": "Tax id exemption updated",
      "splitFrom": "Check split from",
      "splitInto": "Check split into",
      "surchargeAdded": {
        "default": "Fee/Gratuity added",
        "fee": "Fee added",
        "gratuity": "Gratuity added"
      },
      "surchargeAutoDisabled": {
        "default": "Auto-applied Fee/Gratuity disabled",
        "fee": "Auto-applied Fee disabled",
        "gratuity": "Auto-applied Gratuity disabled"
      },
      "surchargeAutoEnabled": {
        "default": "Auto-applied Fee/Gratuity enabled",
        "fee": "Auto-applied Fee enabled",
        "gratuity": "Auto-applied Gratuity enabled"
      },
      "surchargeDisabled": {
        "default": "Fee/Gratuity disabled",
        "fee": "Fee disabled",
        "gratuity": "Gratuity disabled"
      },
      "surchargeEnabled": {
        "default": "Fee/Gratuity enabled",
        "fee": "Fee enabled",
        "gratuity": "Gratuity enabled"
      },
      "surchargeRemoved": {
        "default": "Fee/Gratuity removed",
        "fee": "Fee removed",
        "gratuity": "Gratuity removed"
      },
      "surchargeUpdated": {
        "default": "Fee/Gratuity updated",
        "fee": "Fee updated",
        "gratuity": "Gratuity updated"
      },
      "transferred": "Check transferred",
      "unknown": "Unknown activity",
      "voided": "Check voided"
    },
    "activity": "$t(check.label) Activity",
    "errors": {
      "clear": "clear a check",
      "closeOne": "close one check",
      "createOne": "create one check",
      "getAll": "load checks",
      "getAll_noData": "No $t(check.label_plural) created",
      "getOne": "load current check",
      "removeItem": "remove item",
      "reopenOne": "re-open one check",
      "resolveOne": "load a check",
      "saveItem": "save item",
      "sendItems": "send items",
      "splitAndTransferItems": "split and transfer items",
      "splitItemsAndKeepOnCheck": "split items and keep on current check",
      "updateInfo": "update check info",
      "voidItem": "void item"
    },
    "information": "$t(check.label) Information",
    "instructions": "Create a new check. Choose an $t(orderType.label) below to get started.",
    "label": "Check",
    "label_plural": "Checks",
    "labels": {
      "activityGetOne": "get existing $t(check.label)",
      "addNewCheck": "Add New Check",
      "addNewCheckSplitFrom": "Add New Check - Split From {{checkNumber}}",
      "allChecks": "All Checks",
      "attachGuest": "Attach a guest to {{checkLabel}}",
      "balance": {
        "balance": "Balance Due",
        "balanceValue": "<balance>{{balance, currency(USD)}}</balance>",
        "balanceValue_cashDiscountAvailable": "<balance>{{balance, currency(USD)}}</balance> <cashBalance>({{cashBalance, currency(USD)}} cash)</cashBalance>",
        "discounts": "Discounts",
        "fees": "Fees",
        "gratuities": "Gratuities",
        "overpaid": "Overpayment",
        "subtotal": "Subtotal",
        "tax": "Taxes",
        "tip": "Tip",
        "total": "Total"
      },
      "ccPaymentMethod": "Credit Card Payment Method",
      "checkCleared": "Check {{checkLabel}} has been cleared",
      "checkClosed": "Check {{checkLabel}} has been closed",
      "checkDollarSign": "Check $",
      "checkLabel": "Check Label",
      "checkNumber": "Check #",
      "checkOptions": "Check Options",
      "checkStatus": "Check Status",
      "checkTotal": "Check Total",
      "checkVoided": "Check {{checkLabel}} has been voided",
      "checksAmount": "{{checkAmount}} Checks ",
      "checksAmountWithColon": "{{checkAmount}} Check(s):",
      "checksForTable": "Open Checks for Table {{tableName}}",
      "clearCheck": {
        "action": "Clear Check",
        "prompt": "Are you sure you want to clear this check?",
        "title": "Clear check?"
      },
      "createCheck": "Create a Check",
      "createNew": "Create New Check",
      "currentCheck": "Current Check",
      "customerName": "Customer Name",
      "customerNameNotOnCard": "Customer name is not available on this card",
      "editOlo": "Online ordering ON: {{minutes}}m prep",
      "editOlo_paused": "Online ordering PAUSED: {{minutes}}m prep",
      "editTips": "Tip Edit",
      "fromDate": "{{hours}}h {{minutes}}m",
      "fromDateMinutes": "{{minutes}}m",
      "guestInfo": "Guest Info",
      "itemsVoided": "{{count}} Items Voided",
      "labelPrefix": "Label Prefix",
      "new": {
        "readerInstruction": "Swipe, Insert, or Tap to Authorize"
      },
      "noActivity": "--:--",
      "openCheck": "Open Check",
      "openOrProceedToCheck": "Open/Proceed to Check",
      "paymentAmount": "Payment Amount",
      "paymentDollarSign": "Payment $",
      "paymentTotal": "Payment Total",
      "splitLabel": "Split Check {{checkNumber}} #{{counter}}",
      "startOrder": "Start Order",
      "tabInitialAuthAmount": "Initial Credit Card Amount",
      "table": "Table",
      "tableListOverrides": {
        "status": {
          "Closed": "Closed",
          "MergeVoided": "Merged",
          "Opened": "Open",
          "Scheduled": "Scheduled",
          "Voided": "Voided"
        }
      },
      "tableNumber": "Table {{tableNumber}}",
      "tipDollarSign": "Tip $",
      "updateInfo": "Update $t(check.label) Info",
      "voidCheck": "Void Check",
      "voidCheckPrompt": "Are you sure you want to Void check {{checkNumber}} with {{checkItemsCount}} items totaling {{checkTotal, currency(USD)}}?"
    },
    "new": "New Order",
    "relatedChecks": "Related Checks",
    "related_one": "{{count}} Related Check",
    "related_other": "{{count}} Related Checks",
    "search": "Search $t(check.label_plural)"
  },
  "checkExit": {
    "errors": {
      "sendUnsentItems": "fire unsent check items"
    },
    "prompt": {
      "goBack": "Go back",
      "message": "You have {{count}} unsent items on this check.",
      "send": "Send",
      "title": "Unsent items"
    }
  },
  "checkFees": {
    "errors": {
      "updateAutoFee": "update auto fee/gratuity",
      "updateFee": "update fee/gratuity"
    },
    "labels": {
      "alwaysOn": "Always on",
      "autoApplied": "Auto-applied",
      "editOpenFeeModal": {
        "confirmFee": "Confirm fee",
        "confirmGratuity": "Confirm gratuity",
        "titleFee": "Edit open fee",
        "titleGratuity": "Edit open gratuity",
        "value": "Value"
      },
      "feeValue_amount": "{{value, currency(USD)}}",
      "feeValue_open": "Open",
      "feeValue_percent": "{{value}}%",
      "gratuity": "Gratuity",
      "title": "Fees"
    }
  },
  "checkItem": {
    "defaults": {
      "seatNames": "Seat Position",
      "variantName": "Regular"
    },
    "errors": {
      "createItemDiscount": "create item discount",
      "fireItem": "fire check item",
      "holdItem": "hold check item",
      "overrideItemPrice": "override item price",
      "removeItem": "remove check item",
      "removeItemDiscount": "remove item discount",
      "repeatItem": "repeat check item",
      "save": {
        "invalidModifiers": "Invalid Modifiers",
        "invalidPartialForm": "Resolve Check Item Validation Errors",
        "title": "Save Check Item"
      },
      "scheduleItem": "schedule check item",
      "time": "Time must be in 12 hour format",
      "voidItem": "void check item"
    },
    "labels": {
      "checkItemSave": "Check Item Save",
      "checkQuickView": "Check Quick View - {{checkName}}",
      "confirmHold": "Confirm Hold",
      "confirmSchedule": "Confirm Schedule",
      "delayMinutes": "Delay Minutes",
      "holdInstructions": "Set a hold timer to delay sending {{checkItemName}} for",
      "holdItem": "Hold Item",
      "noChanges": "No changes",
      "onHoldUntil": "On Hold until {{holdUntil}}",
      "scheduleInstructions": "Set a time to send {{checkItemName}}",
      "scheduleItem": "Schedule Item",
      "scheduledFor": "Scheduled for {{scheduledFor}} from now",
      "selectedSeatPositions": "Selected positions: {{selected}}",
      "sendAt": "Send At",
      "voidReasonTitle": "Fill out a reason for the void."
    },
    "nameSplitBy": "{{numerator}}/{{denominator}} {{name}}",
    "price": "<grossLessItemDiscount>{{grossLessItemDiscount, currency(USD)}}</grossLessItemDiscount>",
    "price_hasDiscount": "<gross>{{gross, currency(USD)}}</gross> <grossLessItemDiscount>{{grossLessItemDiscount, currency(USD)}}</grossLessItemDiscount>",
    "quantitySplitBy": "{{numerator}}/{{denominator}}"
  },
  "checkItemActions": {
    "info": {
      "alreadySplit": "You cannot split an item that has already been split.  Please de-select any check item(s) that have already been split.",
      "noSelections": "No check item(s) are selected.  Please select a check item to perform this action."
    }
  },
  "checkItemSplit": {
    "actions": {
      "cancel": "Cancel",
      "save": "Confirm Split"
    },
    "errors": {
      "splitByNumber": "split by number",
      "splitBySeat": "split by seat"
    },
    "info": {
      "confirmation": "Are you sure you want to split the items?",
      "howManyWays": "How many ways do you want to split each item?",
      "warning": "Once an item is split, it cannot be undone."
    },
    "label_one": "Split Item",
    "label_other": "Split Items",
    "labels": {
      "evenSplit": "Even Split",
      "parts": "parts",
      "selectedSeatNames": "Selected positions: {{selectedSeatNames}}",
      "splitByItem": "Split by Item",
      "splitBySeat": "Split By Seat",
      "splitEachBySeat": "Split each item by seat",
      "splitItemWithNames": "Split Item - {{itemNames}}",
      "splitOntoChecks": "Split onto Checks"
    },
    "subTitle_one": "Divide <ItemName>(x{{itemQuantity}}) {{itemName}}</ItemName> into",
    "subTitle_other": "Divide {{itemCount}} items into"
  },
  "checkListEditTip": {
    "footerDescription": "Table {{tableName}} / {{employeeName}} / Closed {{closedTime}} / Check Total {{checkTotal, currency(USD)}}",
    "paymentTotalValue": "Payment Total: {{total, currency(USD)}}"
  },
  "checkMerge": {
    "labels": {
      "noChecks": "No Checks found",
      "noTableSelected": "no check selected",
      "selectDestination": "Select destination check"
    }
  },
  "checkPanelPrintFailures": {
    "title": "{{total}} Print Failures ({{checkItems}} Items)"
  },
  "checkProfile": {
    "errors": {
      "getOne": "load check profile"
    }
  },
  "checkSplit": {
    "info": {
      "assignSeatPositions": "Seat names will be replaced",
      "cantSplitAlreadySplit": "You cannot split an item that has already been split",
      "shouldNotSplitWhenAlreadySplit": "Note: Seat positions cannot be edited after initiating the split and move action.",
      "splitByItem": "Manually select items to move to new checks",
      "splitBySeatPosition": "Automatically split items by seat position assigned",
      "splitEvenly": "Choose number of ways to split all items on the check evenly",
      "switchingChanges": "Switching split method will discard unsaved changes"
    },
    "label": "Split Check",
    "labels": {
      "assignSeatPositions": "Assign Seat Positions",
      "checkSubHeader": "check {{checkNumber}}",
      "checkSubHeader-hasItems": "Check {{checkNumber}} | {{itemCount}} items",
      "checkSubHeader-hasTable": "{{tableName}} | check {{checkNumber}}",
      "checkSubHeader-hasTable-hasItems": "{{tableName}} | Check {{checkNumber}} | {{itemCount}} items",
      "deselect": "Deselect",
      "doneAndPrint": "Done & Print",
      "fromSeatPosition": "From Seat Position",
      "move": "Move",
      "moveHere": "Add to check",
      "reset": "Reset",
      "selectedSeatNameAssign": "Selected check items will be assigned to the following seats: {{selectedSeatNames}}",
      "selectedSeatNameCreate": "Any check items matching the following seats ({{selectedSeatNames}}) will be moved to new checks",
      "split": "Split",
      "splitAndMoveToNewChecks": "Split & Move to New Checks ",
      "splitByItem": "$t(checkSplit.label) by Item",
      "splitBySeatPosition": "Split by seat",
      "splitEvenly": "$t(checkSplit.label) Evenly",
      "splitHere": "Split here",
      "splitItemAndMove": "Split and Move",
      "splitMethod": "Split Method",
      "switch": "Switch",
      "switchSplitMethod": "Switch Split Method"
    }
  },
  "checkSplitAndTransfer": {
    "label": "Split and Transfer",
    "labels": {
      "cardDisplaySize": "Card Display Size",
      "item_plural": "Items",
      "pricePerCheck": "Price Per Check",
      "splitOntoSelectedCheck": "Split onto Selected Checks",
      "table": "TABLE",
      "transfer": "Transfer"
    },
    "title": "Select checks to split item onto."
  },
  "checkTransfer": {
    "errors": {
      "transfer": "transfer check"
    },
    "instruction": "Select destination table and owner.",
    "label": "Transfer Check"
  },
  "clockOut": {
    "error": {
      "title": "current operator clock out"
    },
    "label": "Clock Out",
    "prompt": {
      "cancel": "Cancel",
      "goToCashBanks": "Go to Cash Banks",
      "message": "You have an open cash bank assigned to you. Please close it before clocking out.",
      "printShiftSummary": "Print Shift Summary",
      "shiftSummaryPrompt": "Would you like to print a Shift Summary?"
    }
  },
  "copy": {
    "currency": "<strong>$</strong>{{value}}",
    "negativeCurrency": "- <strong>$</strong>{{value}}",
    "percent": "{{value}}<strong>%</strong>",
    "xCount": "x<strong>{{value}}</strong>"
  },
  "dayparts": {
    "errors": {
      "getAll": "load dayparts"
    },
    "labels": {
      "loadDayPart": "load daypart",
      "loadDayParts": "load dayparts",
      "loadSchedules": "load daypart schedules"
    }
  },
  "devTool": {
    "loyaltyCustomerOnboard": {
      "errors": {
        "enroll": "enroll customer"
      }
    }
  },
  "discount": {
    "errors": {
      "createDiscount": "add a discount to a check",
      "getAll": "load discounts",
      "removeDiscount": "remove a discount from a check",
      "updateAutoDiscount": "update auto discount"
    },
    "label": "Discount",
    "label_plural": "Discounts",
    "labels": {
      "amountApplied": "{{amount}} applied",
      "applyDiscount": "Apply discount",
      "applyDiscounts": "Apply Discounts",
      "autoApplied": "Auto-applied",
      "checkDiscountTitle": "Check Discount",
      "checkItemDiscountTitle": "Check Item Discount",
      "currencyOffEntireOrder": "{{amount, currency(USD)}} Off Entire Order",
      "currencyOffItem": "{{name}} ({{amount, currency(USD)}})",
      "currencyOffItemWithItemName": "{{amount, currency(USD)}} Off {{itemName}}",
      "customNote": "Custom Note",
      "discountDollarAmount": "Discount Dollar Amount: {{amount, currency(USD)}}",
      "enterDiscountAmount": "Enter Discount Amount",
      "enterPromoCodeCheckDiscountOnly": "Enter Promo Code (Check Discount Only)",
      "enterPromoCodeItemDiscountOnly": "Enter Promo Code (Item Discount Only)",
      "limitAmount": "Limit: {{limit, currency(USD)}}",
      "offAmountWithItem": "{{amount, currency(USD)}} off {{itemName}}",
      "offPercentWithItem": "{{amount}}% off {{itemName}}",
      "onAddSuccess": "Discount Applied",
      "onRemoveSuccess": "Discount Removed",
      "openDiscountModalHeader": "Set Amount for {{discountName}} and select a discount reason",
      "percentOffEntireOrder": "{{amount}}% Off Entire Order",
      "percentOffItem": "{{name}} ({{amount}}%)",
      "percentOffItemWithItemName": "{{amount}}% Off {{itemName}}",
      "promoCode": "Promo code",
      "selectReason": "Select a Reason for Discount"
    },
    "validation": {
      "checkDiscountMissing": "discount not found on check",
      "checkItemsMissing": "Check Item(s) do not exist",
      "checkMissing": "Check does not exist",
      "duplicateOnCheck": "{{name}} has already been applied to the check",
      "missingPromoCode": "{{code}} is not a valid code or has expired",
      "notSelected": "Discount was not selected",
      "reasonNotFound": "Discount Reason not found with id: {{reasonId}}"
    }
  },
  "drawer": {
    "label": "Drawer",
    "labels": {
      "popDrawer": "Pop Drawer"
    }
  },
  "editGiftCard": {
    "labels": {
      "editAmount": "Edit amount",
      "title": "Edit Gift Card"
    }
  },
  "employee": {
    "errors": {
      "getAll": "load employees",
      "getShifts": "load employee shifts",
      "getShifts_noData": "No employee shifts"
    },
    "label": "Employee",
    "label_plural": "Employees",
    "labels": {
      "all": "All Employees"
    }
  },
  "endOfDay": {
    "buttons": {
      "cancel": "Cancel",
      "clockOut": "Clock Out",
      "clockOutAll": "$t(endOfDay.buttons.clockOut) All",
      "endDay": "End Day",
      "forceClose": "Force Close",
      "forceCloseAll": "$t(endOfDay.buttons.forceClose) All",
      "printZReport": "Print Z Report",
      "retry": "Retry",
      "retryAll": "Retry All",
      "seeAll": "See All",
      "seeLess": "See Less",
      "sendAll": "Send All"
    },
    "cardBatches": {
      "confirmModal": {
        "message": "Are you sure you want to force {{count}} card batches?",
        "title": "Force Card Batches"
      },
      "label": "Card batches",
      "labelWithCount": "{{count}} $t(endOfDay.cardBatches.label)",
      "notCaptured": "Not captured",
      "title": "{{count}} $t(endOfDay.cardBatches.label) $t(endOfDay.cardBatches.notCaptured)",
      "transactions": "Transactions"
    },
    "cashBanks": {
      "confirmModal": {
        "message": "Are you sure you want to close {{count}} banks?",
        "title": "Force Close Banks"
      },
      "label": "Banks",
      "labelWithCount": "{{count}} $t(endOfDay.cashBanks.label)",
      "stillOpen": "Still open",
      "title": "{{count}} $t(endOfDay.cashBanks.label) $t(endOfDay.cashBanks.stillOpen)"
    },
    "checks": {
      "confirmModal": {
        "message": "Are you sure you want to close {{count}} checks?",
        "title": "Force Close Checks"
      },
      "label": "Checks",
      "labelWithCount": "{{count}} $t(endOfDay.checks.label)",
      "stillOpen": "Still open",
      "title": "{{count}} $t(endOfDay.checks.label) $t(endOfDay.checks.stillOpen)"
    },
    "dailySales": {
      "cashDiscounts": "Cash Discounts",
      "clears": "Clears",
      "discounts": "Standard Discounts",
      "fees": "Fees",
      "gratuities": "Gratuities",
      "grossReceipts": "Gross Receipts",
      "grossSales": "Gross Sales",
      "label": "Daily Sales Report",
      "label_short": "Daily Sales",
      "netSales": "Net Sales",
      "tax": "Tax",
      "taxExempt": "Tax Exempt",
      "tips": "Tips",
      "total": "Total",
      "totalWithAmount": "Total {{count}}",
      "voids": "Voids"
    },
    "errors": {
      "clockout": "Could not clock out shift.",
      "clockoutAll": "Could not clock out all open shifts.",
      "contactSupportWithMessage": "{{message}}. Please contact support.",
      "forceCloseAllCashBanks": "Could not force close all cash banks.",
      "forceCloseAllChecks": "Could not force close all checks.",
      "forceCloseOneCashBank": "Could not force close this cash banks.",
      "forceCloseOneCheck": "Could not force close this check.",
      "get": "Could not fetch end of day statuses.",
      "getZReport": "Could not fetch zReport/Closeout.",
      "runEOD": "Failure occurred while running end of day."
    },
    "label": "End of Day",
    "labels": {
      "fullName": "{{firstName}} {{lastName}}",
      "status": "$t(endOfDay.label) Status",
      "unknownEmployee": "unknown employee"
    },
    "openShifts": {
      "confirmModal": {
        "message": "Are you sure you want to clock out {{count}} employees?",
        "title": "Force Clock Out"
      },
      "label": "Employees",
      "labelWithCount": "{{count}} $t(endOfDay.openShifts.label)",
      "stillClockedIn": "Still clocked-in",
      "title": "{{count}} $t(endOfDay.openShifts.label) $t(endOfDay.openShifts.stillClockedIn)",
      "worked": "Worked {{hours}}h {{minutes}}m"
    },
    "results": {
      "attempt": "Attempt #{{number}}",
      "batchClose": "Batch close",
      "captureTransactions": "Capture transactions",
      "cashBanksClose": "Close cash banks",
      "checksClose": "Close checks",
      "closeoutSummary": "Closeout summary",
      "deleteTrainingData": "Delete training data",
      "description": "EOD failures detected",
      "employeesAutoClockOut": "Employee auto clock out",
      "rerunStoreAndForward": "Good faith transactions",
      "resetCheckNumber": "Reset check number",
      "resetLocationSettings": "Reset location settings",
      "successful": "EOD ran successfully",
      "title": "EOD Results",
      "unassignDrawers": "Unassign drawers",
      "unknown": "Unknown step"
    },
    "saf": {
      "label": "Checks",
      "labelWithCount": "{{count}} $t(endOfDay.saf.label)",
      "title": "{{count}} $t(endOfDay.saf.label) $t(endOfDay.saf.withGoodFaith)",
      "withGoodFaith": "With good faith transactions"
    }
  },
  "feesAndGratuities": {
    "errors": {
      "getAll": "get all fees and gratuities"
    }
  },
  "flipAndTip": {
    "errors": {
      "emailInvalid": "The email you entered is invalid",
      "emailRequired": "The email is required"
    },
    "labels": {
      "checkTitle": "Your Check Summary",
      "continue": "Continue",
      "customAmount": "Custom Amount",
      "customTipAmount": "Custom Tip Amount",
      "emailReceipt": "Email",
      "noReceipt": "No Receipt",
      "noReceiptTitle": "Your transaction is complete",
      "noTip": "No Tip",
      "phoneCode": "Phone code",
      "phoneNumber": "Phone number",
      "printReceipt": "Print Receipt",
      "printReceiptSuccessTitle": "Receipt Requested",
      "receiptSentSuccessTitle": "Your receipt has been sent",
      "receiptSuccessDone": "Done",
      "receiptSuccessText": "Please hand the device back to your server",
      "signHere": "Sign Here",
      "smsReceipt": "SMS",
      "thankYouSubTitle": "Would you like your receipt?",
      "thankYouTitle": "Thank You",
      "totalWithTip": "({{total, currency(USD)}} + {{tip, currency(USD)}} tip)"
    }
  },
  "floorPlan": {
    "createNew": "New Floor Plan",
    "errors": {
      "getAll": "load floor plans",
      "getAllTables": "load tables",
      "initialRequest": "load floor plan initial resources",
      "saveOne": "save a floor plan"
    },
    "label": "Floor Plan",
    "label_plural": "Floor Plans",
    "viewer": {
      "errors": {
        "noRevCentersHeading": "No Revenue Centers",
        "noRevCentersMsg": "Your Location seems to have no Revenue Centers defined. Please define one or more in order to manage floorplans."
      },
      "options": {
        "labels": {
          "checkTimeType": "Open/Last Ordered Time",
          "lastOrderedTime": "Time Since Last Ordered",
          "openTime": "Time Since First Opened",
          "server": "Server",
          "showPartySize": "Show Party Size",
          "showServerInitials": "Show Server Initials",
          "showTimeDuration": "Show Time/Duration"
        },
        "title": "Floor Plan Options"
      },
      "tableOptions": {
        "createCheck": "Start Check",
        "instructions": "Create a new check for Table {{tableName}}. Choose an $t(orderType.label) below to get started.",
        "title": "Table {{tableName}}",
        "viewCheck": "View Check"
      }
    }
  },
  "forgotPassword": {
    "errors": {
      "reset": "trigger password reset"
    },
    "labels": {
      "enterEmailToReset": "Enter email to reset your password",
      "forgotPassword": "Forget Password?",
      "resetPassword": "Reset Password",
      "resetSuccess": "Email sent with password reset instructions"
    }
  },
  "fpo": {
    "lg": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur fugit molestias totam, veniam vero eius iuresed deserunt autem! Impedit atque voluptates soluta explicabo, sapiente corporis delectus voluptatibus incidunt.",
    "lgMultiLine": "Lorem ipsum dolor sit amet consectetur adipisicing elit.<br />Aspernatur fugit molestias totam, veniam vero eius iuresed deserunt autem!<br />Impedit atque voluptates soluta explicabo, sapiente corporis delectus voluptatibus incidunt.",
    "md": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    "mdMultiLine": "Lorem ipsum dolor sit amet consectetur adipisicing elit.<br />Aspernatur fugit molestias totam, veniam vero eius iuresed deserunt autem!",
    "sm": "Lorem ipsum",
    "smMultiLine": "Lorem ipsum<br />Lorem ipsum",
    "xs": "Lorem"
  },
  "giftCard": {
    "errors": {
      "addToCheck": "add gift card to check",
      "adjustDebit": "adjust gift card debit",
      "balance": "get gift card balance",
      "debit": "debit gift card",
      "removeFromCheck": "remove gift card from check",
      "voidDebit": "void gift card debit",
      "zeroBalance": "Gift Card has a balance of $0.00"
    },
    "instruction": "Swipe or manually enter any new or active gift card to get started",
    "instructionOnlyActive": "Swipe or manually enter any active gift card to get started",
    "label": "Gift Card",
    "label_plural": "Gift Cards",
    "labels": {
      "accountNumber": "Account Number",
      "activate": "Activate this Gift Card",
      "addFunds": "Add Funds",
      "addFundsToGiftCard": "Add funds to this Gift Card",
      "addToCheck": "Add to Check",
      "applyToCheck": "Apply to Check",
      "balance": "Gift Card Balance",
      "checkingCardStatus": "Checking card status...",
      "currentBalance": "This card has a balance of {{balance, currency(USD)}}",
      "debit": "Debit Gift Card",
      "lookup": "Lookup",
      "neverActivated": "This gift card has never been activated. Add funds to activate.",
      "noGiftCardPaymentMethods": "No gift card payment methods set up for location.",
      "swipeOrEnter": "Enter the account number below to view the balance"
    }
  },
  "globalPhoneCodes": {
    "labels": {
      "option": "({{code}}) {{region}}",
      "renderedOption": "{{code}} ({{regionAbbr}})"
    }
  },
  "guest": {
    "label": "Guest",
    "label_plural": "Guests"
  },
  "hasChanges": {
    "unsavedChanges": {
      "prompt": "You currently have unsaved changes. Continue and lose all unsaved changes or cancel and stay on the current page.",
      "title": "Unsaved Changes"
    },
    "unsentItems": "You have unsent items. Do you want to send them?"
  },
  "kds": {
    "errors": {
      "getOne": "load kds display"
    }
  },
  "labels": {
    "accept": "Accept",
    "actions": "Actions",
    "activityType": "Activity Type",
    "addCustomer": "Add Customer",
    "addTip": "Add Tip",
    "added": "Added",
    "all": "All",
    "allGroups": "All Groups",
    "amount": "Amount",
    "amountPaid": "Amount Paid",
    "apply": "Apply",
    "approve": "Approve",
    "approveAll": "Approve All",
    "attention": "Attention!",
    "auth": "Auth",
    "available": "Available",
    "back": "Back",
    "balanceDue": "Balance Due",
    "brand": "Brand",
    "breaks": "Breaks",
    "cancel": "Cancel",
    "cardHolder": "Card Holder",
    "cash": "Cash",
    "cashTendered": "Cash Tendered",
    "channel": "Channel",
    "channelUnknown": "Unknown",
    "claim": "Claim",
    "claimed": "Claimed",
    "clear": "Clear",
    "clearedCheck": "Cleared Check",
    "close": "Close",
    "closeCheck": "Close Check",
    "closed": "Closed",
    "closedCheck": "Closed Check",
    "completed": "Completed",
    "configure": "Configure",
    "confirm": "Confirm",
    "confirmChanges": "Confirm Changes",
    "continue": "Continue",
    "cover_plural": "Covers",
    "created": "Created",
    "custom": "Custom",
    "customer": "Customer",
    "customer_plural": "Customers",
    "date": "Date",
    "delete": "Delete",
    "deny": "Deny",
    "denyAll": "Deny All",
    "details": "Details",
    "deviceType": "Device Type",
    "devices": "Devices",
    "difference": "Difference",
    "dismiss": "Dismiss",
    "doNotSend": "Do Not Send",
    "done": "Done",
    "edit": "Edit",
    "editPrice": "Edit Price",
    "edited": "Edited",
    "eightySix": "86",
    "email": "Email",
    "emailAddress": "Email Address",
    "endDate": "End Date",
    "enterNewPrice": "Enter New Price",
    "enterNotes": "Enter Notes",
    "expirationDate": "Expiration Date",
    "favoriteItem": "Favorite Item",
    "favorites": "Favorites",
    "fees": "Fees",
    "fire": "Fire",
    "fromTime": "{{hours}}:{{minutes}}",
    "fullAddress": "{{addr}}, {{city}}, {{state}} {{zip}}, {{country}}",
    "getStarted": "Get Started",
    "giftCard": "Gift Card",
    "giftCardLookup": "Gift Card Lookup",
    "gratuity": "Gratuity",
    "hide": "hide",
    "hold": "Hold",
    "houseAccount": "House Account",
    "integrated": "Integrated",
    "item": "Item",
    "itemDetails": "Item Details",
    "labelSlashGuest": "Label/Guest",
    "large": "large",
    "manualCC": "Manual Credit Card",
    "manualCreditCard": "Manual Credit Card",
    "maskedCard": "Masked Card",
    "medium": "medium",
    "merge": "Merge",
    "merged": "Merged",
    "method": "Method",
    "more": "More",
    "name": "Name",
    "new": "New",
    "next": "Next",
    "noReceipt": "No Receipt",
    "noTable": "No Table",
    "noTablesAvailable": "No Tables Available",
    "noUndo": "This action cannot be undone.",
    "note": "Note",
    "notes": "Notes",
    "off": "off",
    "offline": "Offline",
    "okay": "okay",
    "online": "Online",
    "open": "Open",
    "optional": "Optional",
    "optional_lowerCase": "optional",
    "orderType": "Order Type",
    "originalPrice": "Original Price",
    "other": "Other",
    "otherNotifications": "Other Notifications",
    "otherQuantity": "Other Quantity",
    "owner": "Owner",
    "partySize": "Party Size",
    "password": "Password",
    "pay": "Pay",
    "payTab": "Pay Tab",
    "paymentCard": "Payment Card",
    "paymentType": "Payment Type",
    "phone": "Phone",
    "pin": "PIN",
    "pm": "PM",
    "popDrawer": "Pop Drawer",
    "pos": "Point of Sale",
    "position": "Position",
    "prepAt": "Prep At",
    "price": "Price",
    "priceOverride": "Price Override",
    "print": "Print",
    "printFailed": "Print Failed",
    "printReceipt": "Print Receipt",
    "print_plural": "Prints",
    "printed": "Printed",
    "printer": "Printer",
    "processing": "Processing",
    "provisionedNotReady": "This terminal has been provisioned, but is not able to connect to the server. It will refresh automatically when the connection becomes available.",
    "quantity": "Quantity",
    "reason": "Reason",
    "receipt": "Receipt",
    "refund": "Refund",
    "release": "Release",
    "remove": "Remove",
    "removed": "Removed",
    "reopenCheck": "Re-open Check",
    "repeat": "Repeat",
    "repeatAndTransfer": "Repeat and Transfer",
    "repeated": "Repeated",
    "reprintGuestCheck": "Reprint Guest Check",
    "reprintReceipt": "Reprint Receipt",
    "reprintReceipts": "Reprint Receipts",
    "required": "Required",
    "required_lowerCase": "required",
    "resetFilters": "Reset Filters",
    "resetToUnlimited": "Reset to Unlimited",
    "retry": "Retry",
    "retryAll": "Retry All",
    "save": "Save",
    "saveTip": "Save Tip",
    "schedule": "Schedule",
    "scheduleOrder": "Schedule Order",
    "scheduled": "Scheduled",
    "scheduledFor": "Scheduled For",
    "scheduledUnknown": "Unknown",
    "search": "Search",
    "seatAssignment": "Seat Assignment",
    "selectAll": "Select All",
    "send": "Send",
    "sendAndBack": "Send & Back",
    "sendAndLogout": "Send & Logout",
    "sending": "Sending…",
    "sent": "Sent",
    "small": "small",
    "splitBy": "Split By",
    "splitTender": "Split Tender",
    "startDate": "Start Date",
    "status": "Status",
    "support": "Support",
    "swipeToDismiss": "Swipe to Dismiss",
    "table": "Table",
    "tapForDetails": "Tap for Details",
    "taxExempt": "Tax Exempt",
    "text": "Text",
    "time": "Time",
    "timeClock": "Time Clock",
    "timeClosed": "Time Closed",
    "timeKeeping": "Time Keeping",
    "timeOpen": "Time Open",
    "timeUntilPrep": "Time Until Prep",
    "tip": "Tip",
    "todo": "move shared labels here",
    "token": "Token",
    "total": "Total",
    "trainingMode": "Training Mode",
    "transfer": "Transfer",
    "type": "Type",
    "undo": "Undo",
    "username": "User Name",
    "util": {
      "currency": "{{value, currency(USD)}}",
      "currencyNegative": "- {{value, currency(USD)}}",
      "currencyNegativeWrapped": "(- {{value, currency(USD)}})",
      "dashSeparator": " - ",
      "dotSeparator": " • ",
      "employeeFullName": "{{firstName}} {{lastName}}",
      "hoursMinutes": "{{hours}}h {{minutes}}m",
      "note": "Note: {{value}}",
      "percent": "{{value}}%",
      "percentNegative": "- {{value}}%",
      "range": "{{start}} - {{end}}",
      "wrappedWithParenthesis": "({{value}})"
    },
    "variantAndPrice": "Variant & Price",
    "versionInfo": "Version Info",
    "versionUpdate": "Version Update",
    "view": "View",
    "void": "Void",
    "voidConfirmation": "Void Confirmation",
    "voided": "Voided",
    "voidedCheck": "Voided Check",
    "warning": "Warning",
    "whatIsItFor": "What is it for?"
  },
  "location": {
    "errors": {
      "getAll": "load locations",
      "getBranding": "load location branding"
    },
    "label": "Location",
    "selector": {
      "instruction": "Please select the location for this terminal.",
      "orgLocation": "{{orgName}} Locations",
      "search": "Search Locations"
    }
  },
  "loyalty": {
    "errors": {
      "getCustomerDetails": "get customer details",
      "getProgramEnrollment": "get program enrollment for Location",
      "searchCustomers": "search for customers"
    }
  },
  "menu": {
    "labels": {
      "edit": "Edit Menu"
    }
  },
  "menuInventory": {
    "label": "Menu Inventory"
  },
  "menuItem": {
    "actions": "Item Actions",
    "labels": {
      "allVariants": "Apply to all variants",
      "edit": "Edit: {{name}}",
      "enterPrice": "Please enter a price",
      "inStock": "{{qty}} in stock",
      "loadOne": "load menu item",
      "mark86": "Mark as unavailable (86)",
      "setCount": "Set stock count"
    },
    "sort": {
      "default": "Default Order (Last Added)",
      "favorites": "Favorites",
      "name": "Name",
      "sortByLabel": "Sort by {{label}}"
    }
  },
  "modifier": {
    "choice": {
      "message": {
        "any": "optional",
        "atLeast": "select at least {{minChoices}}",
        "minMax": "select from {{minChoices}} to {{maxChoices}}",
        "onlyOne": "select 1",
        "upToOne": "select up to {{maxChoices}}",
        "wrapped": "({{message}})"
      },
      "validation": {
        "any": "",
        "atLeast": "Valid selections amount of {{choices}} should be at least {{minChoices}}",
        "minMax": "Valid selections amount of {{choices}} in not between the allowed range of {{minChoices}}-{{maxChoices}}",
        "onlyOne": "Valid selections amount of {{choices}} should be 1",
        "upToOne": "Valid selections amount of {{choices}} is greater than allowed amount ({{maxChoices}})"
      }
    },
    "label": "Modifier",
    "label_plural": "Modifiers",
    "labels": {
      "detailGoBack": "Back to Modifiers",
      "load": "load modifiers"
    },
    "selected": {
      "all": "All Selected"
    }
  },
  "modifierCommands": {
    "error": {
      "getAll": "load modifier commands"
    },
    "info": {
      "longPressSelection": "Select multiple modifiers to apply \"<0>{{command}}</0>\" command and add to a check."
    },
    "showCommands": "Show Commands"
  },
  "navigateToCheck": {
    "cantViewChecks": {
      "message": "You are not authorized to perform this action. Please contact your manager or support. Not authorized to view checks.",
      "title": "Unauthorized"
    },
    "cantViewOthersChecks": {
      "message": "You are not authorized to perform this action. Please contact your manager or support. Not authorized to view checks owned by other employees.",
      "title": "Unauthorized"
    }
  },
  "notes": {
    "placeholder": "Add note (optional)"
  },
  "notification": {
    "authRequest": {
      "groupTitle": "Authorization Request",
      "unknownEmployee": "Unknown Employee"
    },
    "eodFailure": {
      "message": "End of Day failed to complete for fiscal day {{fiscalDate}}",
      "title": "End of Day Failure"
    },
    "giftCardChitPrintFailure": {
      "groupPrintingFailed": "{{count}} gift card print jobs failed."
    },
    "isExpandAll": "Minimize All Notifications",
    "isNotExpandAll": "Expand All Notifications",
    "labels": {
      "allTypes": "All",
      "checkUpdate": "Check Update",
      "myNotifications": "My Notifications",
      "noNotifications": "No Notifications",
      "systemNotifications": "System Notifications"
    },
    "modal": {
      "title": "Notifications"
    },
    "printFailure": {
      "collapseDetails": "Collapse Details",
      "displayFailedAt": "$t(check.label) {{checkLabel}} failed to display at {{deviceName}}. {{errStr}}.",
      "displayFailedAtNav": "$t(check.label) <primary>{{checkLabel}}</primary> failed to display at <primary>{{deviceName}}</primary>. {{errStr}}. <navigate>View Check</navigate>",
      "expandDetails": "Expand Details",
      "genericLANPrintFailed": "Print job of type {{printJobType}} failed on {{deviceName}}. {{errStr}}.",
      "giftcardFailedAt": "Gift card Balance failed printing at {{deviceName}}.",
      "groupPrintingFailed": "{{count}} print jobs from check {{checkLabel}} failed printing.",
      "groupTitle": "Printer Error",
      "groupTitleCheck": "Printer Error • {{checkLabel}}",
      "printingFailedAt": "$t(check.label) {{checkLabel}} failed printing at {{deviceName}}. {{errStr}}.",
      "printingFailedAtNav": "$t(check.label) <primary>{{checkLabel}}</primary> failed printing at <primary>{{deviceName}}</primary>. {{errStr}}. <navigate>View Check</navigate>",
      "resolve": "Resolve",
      "resolveAll": "Resolve All",
      "retry": "Retry",
      "retryAll": "Retry All",
      "shiftReportFailed": "Shift report failed to print",
      "unhandledFailedAt": "$t(check.label) {{checkLabel}} failed printing/displaying {{deviceName}}. {{errStr}}.",
      "unhandledFailedAtNav": "$t(check.label) <primary>{{checkLabel}}</primary> failed printing/displaying <primary>{{deviceName}}</primary>. {{errStr}}. <navigate>View Check</navigate>",
      "unknownCheckNumber": "Unknown Number",
      "unknownDevice": "Unknown Device"
    },
    "printSuccess": {
      "shiftReportPrinted": "Shift report has been printed"
    },
    "printerStatus": {
      "badPrinterStatus": "Printer {{printerName}} encountered an error {{errStr}}",
      "resolve": "Resolve",
      "title": "Printer Error",
      "unknownPrinter": "Unknown Printer"
    },
    "s2pCheckPaid": {
      "message": "Check {{checkLabel}} has been paid in full via scan-to-pay",
      "title": "Check Paid • {{checkLabel}}"
    },
    "safTransaction": {
      "groupSAFTransactions": "{{count}} checks with Good Faith transactions (processed offline).",
      "paymentOfflineCheck": "Payment Offline • {{checkLabel}}",
      "paymentOfflineGroup": "Payment Offline • {{count}} Checks",
      "rerunError": "Error processing payment. Please try again later.",
      "rerunOffline": "Credit card processor still offline. Please try again later.",
      "rerunVoided": "Good Faith transaction voided on check {{checkLabel}}",
      "safTransactionFor": "Good Faith transaction on check {{checkLabel}}",
      "transactionProcessedOffline": "Unable to reach credit card processor. Transaction will be processed offline."
    }
  },
  "olo": {
    "errors": {
      "getOloConfig": "get olo config",
      "updateThrottlingInfo": "update throttling info"
    },
    "labels": {
      "acceptOnlineOrders": "Accept online orders",
      "configTitle": "Online Ordering",
      "deliveryLeadTimeOverride": "Delivery lead time override",
      "leadTimeMinuteOption": "{{value}} minutes",
      "leadTimeReset": "Default",
      "resetToDefault": "Reset to default ({{value}} mins)",
      "takeoutLeadTimeOverride": "Takeout lead time override"
    }
  },
  "openBank": {
    "label": "Open Bank"
  },
  "orderChannel": {
    "labels": {
      "all": "All Order Channels"
    },
    "names": {
      "1": "POS",
      "2": "Kiosk",
      "3": "Online",
      "4": "3rd Party",
      "5": "POS Handheld"
    }
  },
  "orderStatus": {
    "labels": {
      "all": "All Checks"
    }
  },
  "orderType": {
    "all": "All $t(orderType.label_plural)",
    "error": {
      "getAll": "load order types"
    },
    "label": "Order Type",
    "labelUnknown": "Unknown",
    "label_plural": "Order Types"
  },
  "organization": {
    "errors": {
      "getAll": "load organizations"
    },
    "label": "Organization",
    "label_plural": "Organizations",
    "selector": {
      "search": "SEARCH ORGANIZATION"
    }
  },
  "otherPaymentOptions": {
    "label": "Other Payment Options",
    "label_plural": "Other Payment Options",
    "labels": {
      "enterPaymentValue": "Enter Payment Value"
    }
  },
  "payInOut": {
    "errors": {
      "getAll": "load pay ins/pay outs",
      "getAllReasons": "load pay in/out reasons",
      "getAll_noData": "No Pay In/Pay Out Data",
      "payIn": "perform pay in",
      "payInManual": "perform manual pay in",
      "payOut": "perform pay out",
      "void": "void pay in/out"
    },
    "label": "Pay In/Pay Out",
    "labels": {
      "allEmployees": "All Employees",
      "allPaymentMethods": "All Payment Methods",
      "allTypes": "All Types",
      "ccPaymentMethod": "Credit Card Payment Method",
      "confirmPayIn": "Confirm Pay In",
      "confirmPayInVoid": "Confirm void of this Pay In record?",
      "confirmPayOut": "Confirm Pay Out",
      "confirmPayOutVoid": "Confirm void of this Pay Out record?",
      "notReversible": "Warning: This Action is NOT Reversible",
      "otherPaymentMethod": "Other Payment Method",
      "payIn": "Pay In",
      "payInAmount": "Pay In Amount",
      "payInCardReaderOperation": "Pay In Card Reader Operation",
      "payInConfirmSuccess": "Payment Approved. Pay In has been recorded.",
      "payInConfirmTitle": "Pay In Confirmation",
      "payInDeclined": "Declined",
      "payInDetails": "Pay In Details",
      "payInErrorEPX": "Payment received an unexpected response from EPX. Pay In was not successful.",
      "payInNotes": "Enter Additional Pay In Notes",
      "payInOutLog": "Pay In/Pay Out Log",
      "payInProcessAndRecord": "Process and Record Pay In",
      "payInReason": "Pay In Reason",
      "payInReasonsNotAvailable": "No Pay In reasons available",
      "payInRecord": "Record Pay In",
      "payManualEpxBtn": "Manual Payment ( EPX )",
      "payOut": "Pay Out",
      "payOutAmount": "Pay Out Amount",
      "payOutConfirm": "Payment Approved. Pay Out has been recorded",
      "payOutConfirmTitle": "Pay Out Confirmation",
      "payOutDetails": "Pay Out Details",
      "payOutNotes": "Enter Additional Pay Out Notes",
      "payOutProcessAndRecord": "Process and Record Pay Out",
      "payOutReason": "Pay Out Reason",
      "payOutReasonsNotAvailable": "No Pay Out reasons available",
      "payOutRecord": "Record Pay Out",
      "paymentMethod": "Payment Method",
      "printPayIn": "Print Pay In",
      "printPayOut": "Print Pay Out",
      "reasonSlashNotes": "Reason/Notes",
      "selectOperationType": "Select operation type.",
      "viewLog": "View Pay In/Pay Out Log",
      "voidPayIn": "Void Pay In",
      "voidPayOut": "Void Pay Out"
    }
  },
  "payment": {
    "action": {
      "acceptCash": "Accept Cash",
      "configCardReader": "Configure Card Reader",
      "selectCCMethod": "Select Credit Card Method",
      "selectGCMethod": "Select Gift Card Method"
    },
    "error": {
      "adjust": "adjust preAuth",
      "adjustables": "load tip adjustable payments",
      "adjustables_noData": "No Tip Adjustable Payments",
      "charge": "make a charge",
      "createCash": "create cash payment",
      "deletePayment": "delete payment",
      "epxPreAuthManual": "manual pre-authorize",
      "epxSaleManual": "manual sale",
      "failedToEmailReceipt": "Failed to email receipt",
      "failedToSMSReceipt": "Failed to send sms receipt",
      "getAll": "load payment types",
      "otherPayment": "other type payment",
      "preAuth": "pre auth",
      "safRetry": "retry processing good faith transaction",
      "sale": "sale",
      "sendReceipt": "send receipt"
    },
    "info": {
      "cardCommError": "CAN'T READ DATA FROM CARD, please remove the card, then click the \"Pay\" button once more",
      "cardDeclined": "Card Declined",
      "cardNotConnected": "CARD READER NOT CONNECTED",
      "cardTimeout": "TIMEOUT WAITING FOR CARD, please click the \"Pay\" button once more",
      "ccPaymentMethodsNotDefined": "No EPX payment method defined. Unable to take card payment.",
      "changeDue": "Change Due {{change, currency(USD)}}",
      "chipReadUnsuccessfulPleaseSwipe": "Chip Read Unsuccessful: Please swipe card",
      "duplicateCard": "This card was recently charged {{amount, currency(USD)}} on the same check. Are you sure you want to charge this card again?",
      "duplicateCardTitle": "Card used",
      "duplicateCardTransaction": "{{cardBrand}} - {{lastFourCcNumber}}",
      "epxPartialApproval": "Approved for a smaller amount than requested.",
      "epxShouldVerifyId": "POS operator needs to check ID of customer and void the transaction if a valid ID with matching name is not shown.",
      "expiredCard": "Card Declined: Expired Card",
      "insufficientFunds": "Card Declined: Insufficient Funds",
      "invalidCard": "Card Read Error: Invalid Card",
      "manualError": "Manual payment failed. Please try again.",
      "pleaseRemoveCard": "Please Remove Card",
      "pleaseSwipeAgain": "Card Read Error: Please retry",
      "pleaseSwipeCard": "Card Read Error: Please swipe card",
      "pleaseTapAgain": "Card Read Error: Please tap card again",
      "pleaseWait": "Please wait",
      "referToConsumerDevice": "Please refer to consumer device",
      "startWithTabDeclined": "Please try another card or proceed to check to accept another payment method.",
      "suspectedFraud": "Card Declined: Suspected Fraud",
      "swipeCard": "Please swipe card"
    },
    "instruction": "Swipe, Insert, or Tap to Pay",
    "instructionWithAmount": "Swipe, Insert, or Tap to Pay {{amount, currency(USD)}}",
    "label": "Payment",
    "label_plural": "Payments",
    "labels": {
      "addUnpaidBalance": "Add unpaid balance ({{balance, currency(USD)}})",
      "adjustTips": "Adjust Tips",
      "amountPaidVsDue": "{{paid, currency(USD)}} paid ({{due, currency(USD)}} due)",
      "amountPaidVsTotal": "{{paid, currency(USD)}} paid ({{total, currency(USD)}} total)",
      "auth": "AUTH",
      "authorizedCard": "Authorized Card",
      "authorizedCardRemoved": "Authorized Card Removed",
      "cardHolderNotPresent": "Cardholder Not Present ( email or phone )",
      "cardHolderPresent": "Cardholder Present",
      "cardHolderStatus": "Cardholder",
      "cashBasis": "Paying for {{amount, currency(USD)}} of balance",
      "changeDue": "Change Due",
      "changeDueItem": "{{change, currency(USD)}} due",
      "checkHasBeenPaid": "Check {{checkLabel}} has been paid",
      "customAmount": "Custom Amount",
      "customCashAmount": "Custom Cash Amount",
      "declined": "Declined",
      "dynamicAmount": "{{amount, currency(USD)}}",
      "editAmount": "Edit Amount",
      "editPayment": "Edit Payment",
      "exact": "{{amount, currency(USD)}} (Exact)",
      "giftCardDebitDeclined": "Gift Card debit was declined",
      "giftCardInfo": "Gift Card {{maskedAccount}}",
      "isCardPresent": "Is credit card present?",
      "manualPaymentPending": "Pending Manual Entry",
      "partialPayment": "Partial Payment",
      "partialPaymentInstructions": "Enter an amount to pay part of the bill",
      "payForPortion": "Please pay for this portion of the check",
      "paymentAdjustmentDeclined": "Payment adjustment was declined",
      "paymentApproved": "Payment Approved",
      "paymentComplete": "Payment Complete",
      "paymentDeclined": "Payment Declined",
      "paymentDeclinedOnCheck": "Payment Declined on Check {{checkLabel}}",
      "paymentError": "Payment request encountered an unexpected error",
      "paymentInfo": "{{cardBrand}} - {{lastFour}}",
      "paymentInfoCash": "{{tendered, currency(USD)}} cash ({{change, currency(USD)}} change due)",
      "paymentInfoOther": "{{tendered, currency(USD)}} {{paymentMethodName}} ({{change, currency(USD)}} change due)",
      "paymentProcessing": "Processing Payment...",
      "paymentVoided": "Payment Voided",
      "remainingGiftCardBalance": "{{balance, currency(USD)}} remaining on gift card",
      "removeCard": "Remove Card",
      "removeOverPaidBalance": "Remove overpayment ({{balance, currency(USD)}})",
      "removePaymentDeclined": "Payment removal was declined",
      "sixty": "$60",
      "splitCheckEvenlyCount": "Split payment evenly: {{count}} of {{totalParts}}",
      "splitEvenly": "Split Evenly",
      "splitIntoParts": "Split payment into how many parts",
      "tipAmount": "({{tip, currency(USD)}} tip)",
      "tryPayAgain": "Try payment again",
      "voidGiftCardDebitDeclined": "Gift Card void debit was declined",
      "voidPayments": "Void Payments"
    },
    "prompt": {
      "declined": {
        "message": "Amount: {{amount}}",
        "title": "Payment Declined"
      },
      "receipt": "Would you like a receipt?",
      "success": {
        "message": "Amount: {{amount}}",
        "title": "Payment Success"
      }
    },
    "validation": {
      "max": "Amount must be less than or equal to {{amount, currency(USD)}}",
      "moreThan": "Amount must be greater than {{amount, currency(USD)}}"
    }
  },
  "paymentComplete": {
    "page": {
      "title": "Pay Complete"
    }
  },
  "paymentMethod": {
    "errors": {
      "getAll": "get all payment methods"
    }
  },
  "posLogin": {
    "__explanation": "This is the login view for POS|TimeClock terminals, not to be confused with provisioner login.",
    "endBreakDialog": {
      "actionDoNotEndBreak": "Do Not End Break",
      "actionEndBreak": "End Break",
      "actionStayOnBreak": "Stay on break",
      "bodyEndBreak": "Do you want to end your break? Note that your system access will resume once you have ended your break.",
      "titleEndBreak": "Employee On Break"
    },
    "errors": {
      "beginBreak": "current operator begin break",
      "clockOut": "current operator clock out",
      "endBreak": "end break",
      "getDrawersFromServer": "get cash drawers from server",
      "loginWithPin": "login with pin",
      "logout": "current operator logout",
      "printShiftSummary": "current operator print shift summary"
    },
    "invalidLoginDialog": {
      "defaultMsg": "Invalid PIN / Card code. Please try again.",
      "title": "Unable to sign in"
    },
    "timeClockDialog": {
      "bodyClockedIn": "You clocked in as <strong>{{jobPositionName}}</strong> at <strong>{{time}}</strong>.",
      "bodyClockedOut": "You clocked out as <strong>{{jobPositionName}}</strong> at <strong>{{time}}</strong>.",
      "titleClockedIn": "Clocked In",
      "titleClockedOut": "Clocked Out"
    }
  },
  "prepTime": {
    "labels": {
      "unknown": "Unknown"
    }
  },
  "printRetry": {
    "errors": {
      "dismiss": "dismiss print failure",
      "retry": "retry print job"
    }
  },
  "printer": {
    "errors": {
      "getAll_noData": "No $t(printer.label_plural)",
      "uatGuestFail": "UAT Guest Failure",
      "uatPrintFail": "UAT Print Failure"
    },
    "label": "Printer",
    "label_plural": "Printers",
    "labels": {
      "failedCount": "{{count}} failed",
      "missingPrinterName": "unknown printer",
      "noPrint": "No Print",
      "noPrinter": "No Printer",
      "printJobs": "Print Jobs",
      "retrySelected": "Retry Selected ({{count}})",
      "successCount": "{{count}} succeeded",
      "unknownPrintState": "Unknown Print State"
    }
  },
  "provision": {
    "emailWorkFlow": {
      "labels": {
        "device": "Device",
        "finish": "Finish",
        "location": "Location",
        "signIn": "Sign In"
      }
    },
    "errors": {
      "killTerminal": "Kill Terminal",
      "noConnection": "The network is not connected.",
      "provisionTerminal": "Provision Terminal",
      "workflowAuth": "workflow authorization"
    },
    "labels": {
      "claim": "Claim",
      "greeting": "Hi {{name}}!",
      "loadTerminal": "Load Terminal",
      "loadingTerminalSettings": "Loading Terminal Settings",
      "orgSelect": "Please select the organization for this terminal."
    },
    "landing": {
      "labels": {
        "enterDeviceCode": "Enter Device Code",
        "setupYourDevice": "Set Up Your Device",
        "signInWithEmail": "Sign in with Email",
        "welcomeTo": "Welcome to"
      }
    },
    "login": {
      "info": {
        "signIn": "Please sign in with your SALIDO Bridge account."
      }
    },
    "terminalClaimed": {
      "info": {
        "assignedTo": "This terminal will be assigned to:",
        "claimedUponClicking": "This terminal will be claimed upon tapping \"CLAIM\" below.",
        "claiming": "Claiming Terminal...",
        "deviceCurrentlyClaimed": "<0>This device is currently claimed by another terminal. In order to assign it to this terminal you must release it from its current terminal.<br /><br /><strong>Would you like to release it? This cannot be undone.</strong></0>",
        "knownAs": "Known as the following device:"
      },
      "labels": {
        "cancel": "CANCEL",
        "deviceClaimed": "DEVICE CLAIMED",
        "release": "RELEASE"
      }
    },
    "tokenWorkFlow": {
      "labels": {
        "claim": "Claim",
        "enterToken": "Enter Token"
      }
    },
    "tokenWorkflow": {
      "autoPairInfo": "This will automatically pair your terminal with the correct device",
      "instructions": "Please enter your 12 character device code",
      "whereFindCode": "Where do I find my device code?",
      "whereFindCodeDetail": "To find your device code, navigate to the Bridge, go to Hardware > Terminals, and generate the 12-digit code for the terminal you need."
    }
  },
  "remoteClockout": {
    "labels": {
      "message": "You have been remotely clocked out. This terminal will refresh in 5 seconds.",
      "title": "Remote Clockout"
    }
  },
  "revenueCenter": {
    "errors": {
      "getAll": "load revenue centers"
    },
    "label": "Revenue Center",
    "label_plural": "Revenue Centers",
    "labels": {
      "all": "All Revenue Centers",
      "unknown": "Unknown Rev Center"
    },
    "shortLabel": "Rev Center"
  },
  "seatAssignment": {
    "labels": {
      "seat": "Seat {{number}}",
      "seatShort": "S{{number}}",
      "table": "Shared",
      "tableShort": "T"
    }
  },
  "service": {
    "Check": {
      "error": {
        "addGiftCard": "add gift card to check",
        "allocateNextNumber": "allocate new check number",
        "balanceSplits": "split check balance",
        "clear": "clear a check",
        "create": "create one check",
        "createDiscount": "add a discount to a check",
        "createItem": "create one check item",
        "getAll": "load checks",
        "getAllHeaders": "load checks",
        "getAllTipSuggestions": "load tip suggestions",
        "getOne": "load a check",
        "getTaxId": "load tax exemption for check",
        "mergeCheck": "merge check",
        "overrideItemPrice": "override item price",
        "printCheck": "print check",
        "removeDiscount": "remove a discount to a check",
        "removeGiftCard": "remove gift card from a check",
        "removeItem": "void item",
        "repeatItems": "repeat check item(s)",
        "repositionItems": "reposition check items",
        "sendAt": "schedule check item(s)",
        "setTaxId": "set tax exemption on check",
        "splitCheck": "split check",
        "transferCheck": "transfer check",
        "updateCustomer": "update check customer",
        "updateFee": "update check fee/gratuity",
        "updateInfo": "update check info",
        "updateItem": "update one check item",
        "updateItemStatus": "update check item(s) status",
        "updateStatus": "update check status"
      }
    },
    "CheckProfile": {
      "error": {
        "getOne": "load a check profile"
      }
    },
    "Discount": {
      "error": {
        "getOne": "load discounts"
      }
    },
    "Menu": {
      "error": {
        "getModifiers": "load modifiers",
        "getOneMenuItem": "load menu item",
        "updateQty": "update menu item quantity"
      }
    },
    "MenuScreen": {
      "error": {
        "getOne": "load menu screen",
        "search": "menu screen search"
      }
    },
    "ModifierCommand": {
      "error": {
        "getAll": "load modifier commands"
      }
    },
    "Printer": {
      "error": {
        "getAll": "load printers",
        "send": "print one",
        "uatGuest": "print one guest",
        "uatPayment": "print one payment",
        "updateStatus": "update printer status"
      }
    }
  },
  "settings": {
    "error": {
      "noPrinterSelected": "No printer selected"
    },
    "info": {
      "configureCardReader": "Please select Configure below to connect or disconnect a {{cardReaderModel}}",
      "noCardReaderConnected": "Please connect or pair a card Reader",
      "usingPrinter": "Current device {{terminalName}} is using the following printer:"
    },
    "label": "Settings",
    "labels": {
      "average": "Average (ms): {{deltaAverage}}",
      "cardReader": "Card Reader",
      "deltas": "Deltas (ms): {{deltas}}",
      "errors": "Errors: {{errors}}",
      "layout": "Customized Layout",
      "localNetworkPrinters": "Available Local Network Printers",
      "networkTest": "Network Test",
      "noCardReaderButton": "PAIR",
      "printTestReceipt": "Print Test Receipt",
      "printers": "Printers",
      "selectPrinter": "Select Printer",
      "startNetworkTest": "Start Network Test",
      "unassignPrinter": "Unassign Printer"
    }
  },
  "shiftReport": {
    "label": "Shift Report",
    "label_plural": "Shift Reports",
    "labels": {
      "printSuccess": "{{firstName}} {{lastName}}'s $t(shiftReport.label) has been printed"
    },
    "search": "Search by employee or position"
  },
  "splitPayment": {
    "label": "Split Payment"
  },
  "splitTender": {
    "action": {
      "addCash": "Add Cash",
      "addManualCreditCard": "Add Manual Credit Card",
      "addOtherPayments": "Add Other Payments",
      "closeCheck": "Close Check"
    },
    "error": {
      "noPayment": "No payment added"
    },
    "instruction": "Swipe, Insert, or Tap to Add a Payment",
    "label": "Split Tender"
  },
  "statusReports": {
    "label": "Status Reports",
    "labels": {
      "statusAndReports": "Status & Reports"
    }
  },
  "support": {
    "label": "Support"
  },
  "taxExempt": {
    "placeholder": "Enter Tax Id"
  },
  "terminal": {
    "errors": {
      "getTerminal": "get terminal",
      "updateHardwareInfo": "update terminal hardware info",
      "updatePrinterID": "update terminal printer",
      "whenInitialized": "terminal when initialized"
    },
    "label": "Terminal",
    "selector": {
      "instruction": "Please select the device this terminal will be known as:"
    }
  },
  "useError": {
    "401": {
      "msg": "Authentication failed - please sign in and try again.",
      "title": "Error Processing Request"
    },
    "403": {
      "msg": "You are not authorized to perform this action. Please contact your manager or support.",
      "title": "Unauthorized"
    },
    "404": {
      "msg": "A requested resource was not found.",
      "title": "Resource Not Found"
    },
    "defaultActivity": "perform requested action",
    "error": {
      "general": {
        "msg": "{{error}}",
        "title": "Failed to {{activity}}"
      },
      "timeout": {
        "msg": "Timed out while trying to {{activity}}",
        "title": "Request Timed Out"
      },
      "unexpected": {
        "msg": "Error encountered while trying to {{activity}}",
        "title": "Unexpected Error"
      },
      "validation": {
        "msg": "Unable to {{activity}}",
        "title": "Validation Errors Encountered"
      }
    }
  },
  "userMenu": {
    "breaksRemaining": "{{numBreaks}} remaining",
    "clockedInAt": "Clocked in: {{clockInTime}} ({{diffHours}} hour, {{diffMins}} min)",
    "clockedInAt_moreThanDay": "Clocked in: {{clockInTime}} (> 24 hours)",
    "logout": "Log Out"
  },
  "voidReason": {
    "error": {
      "getAll": "load void reasons"
    },
    "label": "Void Reason",
    "label_plural": "Void Reasons",
    "labels": {
      "selectOne": "Select a Void Reason"
    }
  }
}